module.exports = __webpack_public_path__ + "img/couples-009.fd701aa0.jpg";